export default {
    show: 'Show',
    'archived': 'Archived',
    'revolved': 'Revolved',
    'locked': 'Locked',
    'active': 'Active',
    'no-$-financial-files': 'No {state} financial files',

    'revolved-to-$': 'Revolved to "{financialFile}"',
}